export default "__VITE_ASSET__Bu1JmAix__"